import React from 'react'
import Nav from '../nav/Nav'

function Contact() {
  return (
    <>
<div>
      <style dangerouslySetInnerHTML={{__html: "\n        iframe {\n\n            position: relative;\n\n            height: 450px;\n\n            border-radius: 7px;\n\n        }\n\n        .bdr-bottom {\n\n            border-bottom: 1px solid rgb(7, 39, 68);\n\n            padding: 30px 0;\n\n        }\n    " }} />

  <div className="sub-banner-section-outer position-relative">
    <header>
      <Nav />
    </header>
    {/* SUB-BANNER SECTION */}
    <section className="banner-section position-relative">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <div className="banner-section-content">
              <h1 className="text-white" >Contact Us</h1>
              <p className="text-white" >Contact Details</p>
              <div className="btn_wrapper" >
                <span> Home </span><i className="fa-solid fa-angles-right" aria-hidden="true" /><span className="sub_span">Contact Us</span>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <div className="banner_image position-relative">
              <figure className="banner_main_image mb-0 left_right_shape">
                <img src="./assets/images/contact_banner_image.jpg" alt />
              </figure>
              <figure className="banner_image_bottom_shape mb-0 position-absolute top_bottom_shape">
                <img src="./assets/images/sub_banner_image_bottom_shape.png" alt className="img-fluid" />
              </figure>
            </div>
          </div>
        </div>
      </div>
    </section>
    <figure className="banner_top_shape mb-0 position-absolute top_bottom_shape">
      <img src="./assets/images/sub_banner_top_shape.png" alt className="img-fluid" />
    </figure>
    <figure className="banner_background_shape mb-0 position-absolute left_right_shape">
      <img src="./assets/images/sub_banner_background_shape.png" alt />
    </figure>
  </div>
  {/* CONTACT INFO SECTION */}
  <section className="contact_info_section position-relative bdr-bottom">
    <div className="container">
      <div className="row">
        <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="contact_info_content">
                <h6>Our information</h6>
                <h2>Contact Info</h2>
              </div>
            </div>
          </div>
          <div className="row" >
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="contact_info_box hover-effect">
                <figure className="mb-0">
                  <img src="./assets/images/location.png" alt className="img-fluid hover-effect" />
                </figure>
                <div className="contact_info_box_content_wrapper">
                  <h5>Location:</h5>
                  <p className="mb-0">1018 Murphy Dr, Great Falls,&nbsp;VA&nbsp;22066,&nbsp;USA</p>
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="contact_info_box hover-effect">
                <figure className="mb-0">
                  <img src="./assets/images/email.png" alt className="img-fluid hover-effect" />
                </figure>
                <div className="contact_info_box_content_wrapper">
                  <h5>Email Us:</h5>
                  <p className="mb-0"><a href="mailto:info@gaztec.com" className="text-decoration-none">info@gaztec.com</a></p>
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="contact_info_box hover-effect">
                <figure className="mb-0">
                  <img src="./assets/images/phone.png" alt className="img-fluid hover-effect" />
                </figure>
                <div className="contact_info_box_content_wrapper">
                  <h5>Phone:</h5>
                  <p className="mb-0"><a href="tel:+17034888707" className="text-decoration-none">+17034888707
                    </a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12"  id="contact-GazTecForge ">
          <div className="contact_info_form_content">
            <h4>Send us a Message</h4>
            <form id="contactpage" method="POST" action="contact-mail.php">
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="form-group mb-0">
                    <input type="text" name="name" id="name" className="form-control" placeholder="Name:" />
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="form-group mb-0">
                    <input type="tel" name="phone" id="phonenum" className="form-control" placeholder="Phone:" />
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="form-group mb-0">
                    <input type="email" name="emailaddress" id="emailaddrs" className="form-control" placeholder="Email:" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className=" form-group mb-0">
                    <textarea rows={3} name="msg" id="comment" className="form-control" placeholder="Message:" defaultValue={""} />
                  </div>
                </div>
              </div>
              <div className="btn_wrapper">
                <button type="submit" name="get_started" id="started" className="default-btn">Submit Now<i className="fa-solid fa-angle-right" /></button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <figure className="contact_info_left_shape mb-0 position-absolute top_bottom_shape">
        <img src="./assets/images/contact_info_left_shape.png" alt className="img-fluid" />
      </figure>
    </div>
    <div className="col-lg-12 pt-5">
      <div className="container">
        <div className="row">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3101.58357164284!2d-77.28875127540958!3d38.97917574187566!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b636746e539d8b%3A0x828059c5ad8cbabf!2zMTAxOCBNdXJwaHkgRHIsIEdyZWF0IEZhbGxzLCBWQSAyMjA2NtiMINin2YTZiNmE2KfZitin2Kog2KfZhNmF2KrYrdiv2Kk!5e0!3m2!1sar!2sae!4v1727517112594!5m2!1sar!1sen" width="100%" height={450} style={{border: 0}} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
        </div>
      </div>
    </div>
  </section>
</div>

    </>
  )
}

export default Contact